import { ScrollArea, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewEditGoodsItemFormValues } from '@e-origin/contracts';

import { TSDTransportEquipment } from '../../TSDTransportEquipment';

interface GoodsItemTransportProps {
  goodsItemForm: UseFormReturnType<TSDViewEditGoodsItemFormValues>;
  disabled: boolean;
}

export const GoodsItemTransport: React.FC<GoodsItemTransportProps> = ({ goodsItemForm, disabled }) => {
  return (
    <ScrollArea h="50vh" offsetScrollbars="y">
      <Stack mt="md">
        <Stack mb="sm">
          <Title order={5} fw={600}>
            Transport equipment
          </Title>

          <TSDTransportEquipment form={goodsItemForm} disabled={disabled} />
        </Stack>
      </Stack>
    </ScrollArea>
  );
};
